module.exports = __webpack_public_path__ + "img/Photo46.815c2306.jpg";